<template>
  <v-col cols="10" sm="12" md="10" lg="10" class="d-flex align-stretch pa-1">
    <v-card class="flex-grow-1">
      <v-toolbar color="grey lighten-4" elevation="0" light dense>
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        <v-toolbar-title>Meus Planos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title class="title text-left">{{
        plan.contrato.plano
      }}</v-card-title>
      <v-card-subtitle class="text-left">{{
        plan.contrato.operadorafantasia
      }}</v-card-subtitle>

      <v-card-text class="text--primary mb-4 justify-center">
        <v-row>
          <v-col cols="12" md="5" lg="4">
            <p>Seus cartões</p>
            <v-carousel
              height="250px"
              light
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(item, i) in plan.beneficiarios"
                :key="i"
                pa-3
              >
                <v-card
                  color="white"
                  class="plan-card mx-auto ma-1"
                  max-width="400"
                  width="95%"
                >
                  <v-card-subtitle
                    class="pb-1 text-center font-weight-regular subtitle-1"
                    color="grey"
                    >{{ item.numerocarteira }}</v-card-subtitle
                  >
                  <div
                    style="height: 25px; width: 100%; background-color: #331111"
                  ></div>
                  <v-footer
                    color="white"
                    class="text-center mt-0 pt-0"
                    style="
                      height: 130px;
                      width: 100%;
                      background-color: #331111;
                    "
                  >
                    <v-img
                      class="align-top"
                      height="100px"
                      :src="getSource(plan.contrato.operadorafantasia)"
                      contain
                    >
                      <h5 class="text-left mb-0 mt-0 pb-0 pt-0" color="grey">
                        {{ plan.contrato.plano }}
                      </h5>
                      <h6 class="text-left mb-5 mt-0 pb-0 pt-0" color="grey">
                        {{ plan.contrato.operadorafantasia }}
                      </h6>

                      <p class="pb-1 pt-2 text-left" color="grey">
                        {{ item.nome }}
                      </p>
                    </v-img>
                  </v-footer>
                </v-card>
                <!-- </v-sheet> -->
              </v-carousel-item>
            </v-carousel>
            <!-- <div class="mx-auto ml-0 mt-5 " style="max-width:400px">
                <v-btn block outlined color="primary" v-if="plan.beneficiarios.length > 1"><v-icon left class="mr-4">fal fa-users</v-icon>  TODOS OS SEGURADOS</v-btn>
            </div>-->
          </v-col>
          <v-col cols="12" md="7" lg="8" class="text-left" max-width="400">
            <p class="ml-4 text-left primary--text" v-if="hasExpiredSlip">
              <v-icon small color="primary"
                >fa-solid fa-triangle-exclamation</v-icon
              >
              {{ userName }}, você possui boletos vencidos!
            </p>
            <p class="ml-4 text-left white--text" v-else>_</p>
            <v-expansion-panels focusable accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Dados do Plano
                  <template v-slot:actions>
                    <v-icon small color="primary"
                      >fa-sharp fa-solid fa-chevron-down</v-icon
                    >
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="ml-4 mt-4">
                    <span class="grey--text">Nº do Contrato:</span>
                    {{ plan.contrato.numerocontrato }}
                  </p>
                  <p class="ml-4">
                    <span class="grey--text">Coparticipação:</span>
                    {{ plan.contrato.coparticipacao }}
                  </p>
                  <p class="ml-4 mb-0">
                    <span class="grey--text">Data de vigência:</span>
                    {{ plan.contrato.datavigencia | moment("DD/MM/YYYY") }}
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  2ª via de boletos
                  <template v-slot:actions>
                    <v-icon small color="primary"
                      >fa-sharp fa-solid fa-chevron-down</v-icon
                    >
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Vencimento</th>
                          <th class="text-left">Valor</th>
                          <th class="text-left">Documento</th>
                          <th class="text-left">Código de Barras</th>
                          <th class="text-left">Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in BankSlips" :key="item.id">
                          <td class="text-left">
                            {{ item.datavencimento | moment("DD/MM/YYYY") }}
                          </td>
                          <td class="text-left">
                            {{ item.valordocumento | formatPrice }}
                          </td>
                          <td class="text-left">{{ item.id }}</td>
                          <td
                            class="text-left primary--text"
                            v-if="wasExpired(item.datavencimento)"
                          >
                            <v-icon small color="primary"
                              >fa-solid fa-triangle-exclamation</v-icon
                            >Contacte o departamento financeiro.
                          </td>
                          <td class="text-left">
                            <v-text-field
                              :id="`ipt_${item.id}`"
                              v-model="item.linhaDigitavel"
                              label
                              append-outer-icon="fa-regular fa-copy"
                              @click:append-outer="copyBarcode(item.id)"
                              :hint="
                                copied
                                  ? 'Linha digitável copiada para o clipboard'
                                  : ''
                              "
                            ></v-text-field>
                          </td>
                          <td class="text-left">
                            <v-btn
                              text
                              icon
                              color="secondary darken-4"
                              @click="getUrlOpenBilet(cpf, item.id)"
                            >
                              <!-- :href="'http://www.corporeadministradora.com.br/boletos/?cpf='+cpf+'&idBillet='+item.id+'&ey='+$store.state.ey" -->
                              <v-icon>fa-solid fa-barcode</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
var moment = require("moment");

export default {
  data() {
    return {
      BankSlips: [],
      bgimage: "",
      cpf: null,
      copied: false,
    };
  },
  updated() {
    this.bgimage = this.getSource(plan.contrato.operadorafantasia);
  },
  created() {
    this.cpf = localStorage.corporeUserId;
    this.openedBankSlip(this.plan.fichafinanceira).then((resp) => {
      this.BankSlips = resp;
    });
  },
  props: {
    close: Function,
    hasExpiredSlip: Boolean,
    openedBankSlip: Function,
    plan: Object,
    userName: String,
    wasExpired: Function,
  },
  methods: {
    getUrlOpenBilet(cpf, doc) {
      let obj = {
        url: "/boletos",
        query: { cpf: cpf, codigocobranca: doc },
        method: "post",
      };
      // console.log("sssss");
      this.$store.dispatch("request/doRequest", obj).then((resp) => {
        //console.log(resp);
        if (!resp) {
          return;
        }
        window.open(resp.data.link, '_blank');
      });
    },
    copyBarcode(id) {
      let _this = this;
      var ipt = `ipt_${id}`;
      var copyText = document.getElementById(ipt);
      copyText.select();
      document.execCommand("copy");
      this.copied = true;
      setTimeout(() => {
        _this.copied = false;
      }, 3500);
      return;
    },
    getSource(planName) {
      return this.$store.state.plans.imagensSrc[planName];
    },
  },
};
</script>

<style>
.v-data-table-header-mobile__wrapper {
  display: none;
}
i.v-icon.notranslate.fas.fa-chevron-right.theme--light:before,
i.v-icon.notranslate.fas.fa-chevron-left.theme--light:before {
  font-size: 22px;
}
.v-carousel .v-btn--outlined .v-btn__content .v-icon,
.v-carousel .v-btn--outlined .v-btn__content .v-icon:before,
.v-carousel .v-btn--round .v-btn__content .v-icon,
.v-carousel .v-btn--round .v-btn__content .v-icon:before {
  font-size: 8px;
}
.v-carousel .v-btn--icon.v-size--default .v-icon,
.v-btn--fab.v-size--default .v-icon {
  height: 16px;
  font-size: 8px;
  min-width: 16px;
}
</style>